import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { ModuleRegistry, AllCommunityModule, provideGlobalGridOptions } from 'ag-grid-community';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

ModuleRegistry.registerModules([AllCommunityModule]);
provideGlobalGridOptions({ theme: 'legacy' });

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], })
  .then(() => {
    // Pentest-Haertung: Angular setzt das Attribut "ng-version" mit der genauen
    // Framework-Version auf dem Root-Element - das ist ein Information-Disclosure-Fund.
    document.querySelectorAll('[ng-version]').forEach(el => el.removeAttribute('ng-version'));
  })
  .catch(err => console.error(err));
